import React from "react";
import { X, Smartphone } from "lucide-react";
import TeacherDevicePanel from "./TeacherDevicePanel";

/** Popup quản lý / đổi thiết bị đăng nhập APP của GV đối tác */
const TeacherDeviceManageModal = ({ isOpen, teacher, onClose }) => {
  if (!isOpen || !teacher) return null;

  return (
    <div className="fixed inset-0 z-[140] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-gray-900/60 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <div className="relative flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl border border-white bg-slate-50 shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 bg-white px-6 py-4">
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-sky-50 text-sky-700">
              <Smartphone className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <h2 className="truncate text-lg font-bold text-gray-900">
                Đổi thiết bị đăng nhập
              </h2>
              <p className="truncate text-sm text-gray-500">
                {teacher.name}
                {teacher.email ? ` · ${teacher.email}` : ""}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl p-2 text-gray-500 hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>
        <div className="overflow-y-auto p-6">
          <p className="mb-4 text-xs text-gray-500">
            Mỗi tài khoản: tối đa <strong>1 máy tính</strong> và{" "}
            <strong>1 điện thoại</strong>. Gỡ thiết bị cùng loại trước khi duyệt
            thiết bị mới cùng loại; hoặc để GV đăng nhập loại còn trống (máy tính /
            điện thoại).
          </p>
          <TeacherDevicePanel employeeId={teacher.id} />
        </div>
      </div>
    </div>
  );
};

export default TeacherDeviceManageModal;
